import { jwtDecode } from "jwt-decode";
import "core-js/stable/atob";
import { TokenData } from "../../storage/storageHelper";

enum ClaimType {
  Name = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name",
  Id = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
  Email = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
  Phone = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone",
  Role = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
  Permission = "Permission",
}

export type JWTToken = {
  aud: string;
  exp: number;
  iss: string;
  //   [ClaimType.Name]: string;
  //   [ClaimType.Id]: string;
  //   [ClaimType.Email]: string;
  //   [ClaimType.Phone]: string;
  //   [ClaimType.Role]: any;
  Permission: string | string[];
};

export function checkTokenExpiry(tokenData: TokenData): boolean {
  const now = new Date();
  if (tokenData.expiry) {
    if (tokenData.expiry >= (now.valueOf() + 10000) / 1000) {
      return true;
    }
  } else {
    const decoded = jwtDecode<JWTToken>(tokenData.token);

    if (decoded.exp >= (now.valueOf() + 10000) / 1000) {
      return true;
    }
  }
  console.log("checkTokenExpiry - expired");
  return false;
}

export const getTokenExpiry = (accessToken: string): number => {
  const decoded = jwtDecode<JWTToken>(accessToken);
  return decoded.exp;
};
